export default __webpack_public_path__ + "static/media/will-making.aa58f096.jpeg";